import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../components/Card.jsx";
import RepoForm from "../components/RepoForm.jsx";
import { repoApi } from "../../api/repoApi";
import { getApiError } from "../../api/client";
import "../styles/codebase.css";
export default function RepoEditPage() {
  const { repoId } = useParams();
  const nav = useNavigate();

  const [repo, setRepo] = useState(null);
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    repoApi
      .get(repoId)
      .then((res) => setRepo(res.data))
      .catch((e) => setErr(getApiError(e)));
  }, [repoId]);

  const submit = async (payload) => {
    setErr("");
    setSaving(true);
    try {
      await repoApi.update(repoId, payload);
      nav(`/codebase/repos/${repoId}`);
    } catch (e) {
      setErr(getApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="cb-page">
        <div>
          <h2>Edit Repository</h2>
          <div className="muted">Update non-secret connection metadata</div>
        </div>
      </div>

      {err && <div className="error">{err}</div>}

      <Card title="Repository details">
        {!repo ? <div className="muted">Loading…</div> : <RepoForm initial={repo} onSubmit={submit} submitting={saving} submitLabel="Save" />}
      </Card>
    </div>
  );
}
